import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { CSSProperties } from 'react';

export interface WithImportantProps {
    className?: string;
    style: CSSProperties;
}

export default function withImportantSupport(Comp: any) {
    return class WithImportantComponent extends React.Component<WithImportantProps, any> {
        ref: string;
        element: any;

        constructor(props: WithImportantProps) {
            super(props);

            this.camelToDash = this.camelToDash.bind(this);
            this.handleRef = this.handleRef.bind(this);
        }

        camelToDash(str: string): string {
            return str.replace(/([a-z])([A-Z])/g, (m, a, b) => a + '-' + b.toLowerCase());
        }

        handleRef(ref: any) {
            this.ref = ref;
            this.element = ReactDOM.findDOMNode(ref);
        }

        getRef() {
            return this.ref;
        }

        componentDidMount() {
            this.setImportantStyles();
        }

        componentDidUpdate() {
            this.setImportantStyles();
        }

        setImportantStyles() {
            if (!this.props.style) {
                return;
            }

            Object.keys(this.props.style).forEach(key => {
                const value = this.props.style[key];

                if (value.indexOf('!important') === -1) {
                    return;
                }

                const dashedKey = this.camelToDash(key);

                this.element.style.setProperty(dashedKey, value.replace(/\s*!important/g, ''), 'important');
            });
        }

        render() {
            return <Comp ref={this.handleRef} {...this.props} />;
        }
    };
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/infrastructure/WithImportantComponent.tsx